export { parametrizedWorker } from './parametrized-worker';
